import { LitElement, html, } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { getFormattedDateUTC } from '../../../src/utils/helpers';
import "@maersk-global/mds-components-core/mc-modal";
import { WeatherModel } from '../../../src/models/weather-model';
import { weatherServiceAlertStyles } from '../style/weather-service-alert-styles';


@customElement('weather-service-alert')
export class WeatherServiceAlert extends LitElement {

  @state() private _showWarning: boolean = false;

  static styles = weatherServiceAlertStyles

  constructor() {
    super();
    this.checkWeatherService = this.checkWeatherService.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    WeatherModel!.addEventListener('show-weather-service-warning', this.checkWeatherService);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    WeatherModel!.removeEventListener('show-weather-service-warning', this.checkWeatherService);
  }

  private checkWeatherService() {

    // check if they have been shown alert before, if not show the alert
    const lastForecastWarningTime = localStorage.getItem('lastWarningShownTimestamp');

    if (!lastForecastWarningTime) {
      this._showWarning = true;
      this.requestUpdate();
      return;
    }

    // if they have been shown an alert before and it has been over 24 hours, show it again
    const lastWarningTimeStamp = new Date(JSON.parse(lastForecastWarningTime));
    const dateNow = new Date();
    const warningUpdatedHours = Math.abs((dateNow.getTime() - lastWarningTimeStamp.getTime()) / (60 * 60 * 1000));

    if (warningUpdatedHours >= 24) {
      this._showWarning = true;
      this.requestUpdate();
    }
  }

  // closing the alert, and storing the timestamp to be used to calculate next weather warning alert
  private acceptWarning() {
    this._showWarning = false;
    localStorage.setItem('lastWarningShownTimestamp', JSON.stringify(new Date()));
    this.requestUpdate();
  }


  render() {
    return this._showWarning
      ? html`
        <mc-modal
          ?open=${this._showWarning}
          dimension="small"
          width="525px"
          height="200px"
          backdropcloseactiondisabled
          escapecloseactiondisabled
          entercloseactiondisabled
          hiddenclose
        >
          <span slot="heading">
            <span class="forecast-heading">Weather forecast outdated |  
              <span class="forecast-heading-date">${getFormattedDateUTC(new Date())}</span>
            </span>
          </span>
          <div class="forecast-message">
            Weather Forecast Service Provider (DTN) is currently unavailable.
            ${WeatherModel?.latestForecastInfo?.timestamp ?
          html`Last forecast received on ${getFormattedDateUTC(new Date(WeatherModel.latestForecastInfo.timestamp))}.`
          : ''
        } 
            Please consult an alternative service provider.
          </div>
          <mc-button
            slot="primaryAction"
            appearance="primary"
            @click="${this.acceptWarning}"
          >
            Accept
          </mc-button>
        </mc-modal>
      ` : html``
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'weather-service-alert': WeatherServiceAlert;
  }
}
